import React from 'react';
import './PointBonusTip.css';

export const POINT_BONUS_FEEDBACK_MS = 720;

// The card workout and NPC workout share the same markup, colors and motion.
export default function PointBonusTip({ bonuses, eventId, duration = POINT_BONUS_FEEDBACK_MS }) {
  return <div className="score-bonus-stack" key={eventId} aria-label="Point bonuses"
    style={{ '--score-bonus-feedback-duration': `${duration}ms` }}>
    {bonuses.map(bonus => <div
      className={`score-bonus-chip ${bonus.label === 'Auto Repeat' ? 'score-bonus-chip-auto-repeat' : ''}`.trim()}
      key={`${eventId}-${bonus.label}`}>
      <span className="score-bonus-label">{bonus.label}</span>
      <span className="score-bonus-points">+{bonus.points} pt</span>
    </div>)}
  </div>;
}
